import * as actions from '../actions/mobile.action.js';
import {default_state} from './index.js';
import {MODEL_LOAD} from '../actions/model.action.js';

export function mobile_tab(state=default_state.mobile_tab, action={}, full_state={}){
    switch (action.type) {
        case actions.TOGGLE_MOBILE:
        {
            return {
                ...state,
                isActive: !state.isActive
            };
        }
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/mobile.reducer.js